/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DESKTOP_BREAKPOINT = 1023;
var MAX_BANNER_WIDTH = 1900;
var HeroTextAndButtonMarginHandler = function () {
  function HeroTextAndButtonMarginHandler() {
    _classCallCheck(this, HeroTextAndButtonMarginHandler);
    this.hero = document.querySelector('.paragraph--type--hero-banner.paragraph--view-mode--super-specialty, .paragraph--type--hero-banner.paragraph--view-mode--general-tier-1');
    if (this.hero) {
      this.textGroup = this.hero.querySelector('.hero__text-group');
      this.buttonGroup = this.hero.querySelector('.hero__buttons-group');
    }
  }
  return _createClass(HeroTextAndButtonMarginHandler, [{
    key: "setTextGroupMargin",
    value: function setTextGroupMargin(amountHeaderIsFromLeftOfWindow) {
      this.textGroup.style.marginLeft = "".concat(amountHeaderIsFromLeftOfWindow, "px");
    }
  }, {
    key: "setButtonGroupMargin",
    value: function setButtonGroupMargin(amountHeaderIsFromLeftOfWindow) {
      if (this.buttonGroup) {
        this.buttonGroup.style.marginLeft = "".concat(amountHeaderIsFromLeftOfWindow, "px");
      }
    }
  }, {
    key: "setTextAndButtonsMargin",
    value: function setTextAndButtonsMargin() {
      var siteHeader = document.querySelector('.site-header__inner__container');
      var amountHeaderIsFromLeftOfWindow = siteHeader.getBoundingClientRect().left;
      if (window.innerWidth > MAX_BANNER_WIDTH) {
        this.setTextGroupMargin(amountHeaderIsFromLeftOfWindow - this.hero.getBoundingClientRect().left);
        this.setButtonGroupMargin(amountHeaderIsFromLeftOfWindow - this.hero.getBoundingClientRect().left);
      } else {
        this.setTextGroupMargin(amountHeaderIsFromLeftOfWindow);
        this.setButtonGroupMargin(amountHeaderIsFromLeftOfWindow);
      }
    }
  }, {
    key: "removeMarginSettingFromTextAndButtons",
    value: function removeMarginSettingFromTextAndButtons() {
      this.textGroup.style.removeProperty('margin-left');
      if (this.buttonGroup) {
        this.buttonGroup.style.removeProperty('margin-left');
      }
    }
  }, {
    key: "setMarginOrRemoveBasedOnScreenSize",
    value: function setMarginOrRemoveBasedOnScreenSize() {
      if (this.hero) {
        if (window.innerWidth > DESKTOP_BREAKPOINT) {
          this.setTextAndButtonsMargin();
        } else {
          this.removeMarginSettingFromTextAndButtons();
        }
      }
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      var _this = this;
      window.addEventListener('resize', function () {
        _this.setMarginOrRemoveBasedOnScreenSize();
      });
    }
  }]);
}();
export { HeroTextAndButtonMarginHandler as default };
(function () {
  var heroTextAndButtonMarginHandler = new HeroTextAndButtonMarginHandler();
  heroTextAndButtonMarginHandler.setMarginOrRemoveBasedOnScreenSize();
  heroTextAndButtonMarginHandler.setListeners();
})(Drupal);